export const allFieldsValid = (values: any[]) =>
  values.every((value) => value !== null && value !== undefined && value !== '');
